$(function () {
  const drawer = document.getElementById('LanguageDrawer');
  if (!drawer) return;

  const backdrop = document.querySelector('.lang-switcher__modal__backdrop');
  const triggers = document.querySelectorAll('.lang-switcher__active-lang');
  const closeButton = drawer.querySelector('.lang-switcher__modal__close');
  let activeTrigger = null;
  let previousOverflow = '';

  const closeDrawer = () => {
    if (!drawer.classList.contains('open')) return;

    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.style.overflowY = previousOverflow;
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (activeTrigger) activeTrigger.focus();
    activeTrigger = null;
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      activeTrigger = trigger;
      previousOverflow = document.documentElement.style.overflowY;
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      document.documentElement.style.overflowY = 'hidden';
      triggers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      closeButton.focus();
    });
  });

  closeButton.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  drawer.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;

    const focusable = Array.from(drawer.querySelectorAll('button, a[href]'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('open')) {
      event.preventDefault();
      closeDrawer();
    }
  });
});
